import React from "react";
import PageShell from "@/components/PageShell";
import { MapPin, ArrowUpRight } from "lucide-react";
import { FLAGSHIPS } from "@/data/stockists";

const Stockists = () => {
    return (
        <PageShell
            kicker="[03 Locations]"
            title="Our"
            accent="Locations."
            intro="Three UKnitwear locations. London, San Francisco, San Diego. Walk in. Try it on. Take it home."
            testid="stockists-page"
        >
            <section className="border-y-4 border-black" data-testid="flagships-section">
                <div className="grid grid-cols-1 md:grid-cols-2">
                    {FLAGSHIPS.map((s, i) => (
                        <article
                            key={s.city}
                            className={`relative p-6 md:p-10 border-black ${
                                i % 2 === 0 ? "md:border-r-2" : ""
                            } ${i > 0 ? "border-t-2" : ""} ${
                                i === 1 ? "md:border-t-0" : ""
                            }`}
                            data-testid={`flagship-${i}`}
                        >
                            {s.comingSoon ? (
                                <div className="flex min-h-[24rem] items-center justify-center">
                                    <p className="font-heading text-4xl uppercase tracking-[0.2em] text-foreground/70">
                                        Coming Soon
                                    </p>
                                </div>
                            ) : (
                                <div className="lg:grid lg:h-full lg:grid-cols-[minmax(0,1fr)_24rem] lg:items-stretch lg:gap-8">
                                    <div className="flex min-h-full flex-col lg:h-full">
                                        <div className="flex items-start justify-between gap-3 mb-4">
                                            <span className="bg-black px-2 py-1 font-mono-ui text-[10px] uppercase tracking-[0.3em] text-white">
                                                {s.flag} / Flagship 0{i + 1}
                                            </span>
                                            <MapPin className="w-5 h-5 text-hazard flex-shrink-0" />
                                        </div>
                                        <h3
                                            className={`font-heading uppercase leading-[0.9] ${
                                                s.city.length > 10
                                                    ? "text-4xl sm:text-[2.65rem] lg:text-[2.9rem] xl:text-[3.35rem]"
                                                    : "text-4xl sm:text-[2.85rem] lg:text-[3.5rem]"
                                            }`}
                                        >
                                            {s.city}
                                        </h3>
                                        <address className="mt-4 not-italic font-mono-ui text-sm leading-relaxed text-foreground/90">
                                            {s.street}
                                            <br />
                                            {s.city}, {s.country}
                                            <br />
                                            {s.postal}
                                        </address>
                                        <div className="mt-4 pt-4 border-t-2 border-ink/15">
                                            <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                                                Hours
                                            </p>
                                            <p className="mt-1 font-mono-ui text-xs">{s.hours}</p>
                                        </div>
                                        <a
                                            href={s.maps}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="mt-auto inline-flex items-center gap-2 self-start border-2 border-black bg-black px-5 py-2.5 font-mono-ui text-[11px] uppercase tracking-[0.25em] text-white transition-colors hover:border-hazard hover:bg-hazard"
                                            data-testid={`flagship-directions-${i}`}
                                        >
                                            Get Directions <ArrowUpRight className="w-3 h-3" />
                                        </a>
                                    </div>
                                    {s.gallery?.length ? (
                                        <div className="mt-6 overflow-hidden border-2 border-black bg-muted/20 lg:mt-0 lg:flex lg:h-full lg:flex-col">
                                            <img
                                                src={s.gallery[0].src}
                                                alt={s.gallery[0].alt}
                                                className={`w-full object-cover ${
                                                    s.gallery.length > 1
                                                        ? "h-56 lg:min-h-0 lg:flex-1"
                                                        : "h-[25rem] lg:h-full"
                                                }`}
                                                loading="lazy"
                                            />
                                            {s.gallery.length > 1 ? (
                                                <div className="grid grid-cols-2 border-t-2 border-black">
                                                    {s.gallery.slice(1, 3).map((image, imageIndex) => (
                                                        <img
                                                            key={image.src}
                                                            src={image.src}
                                                            alt={image.alt}
                                                            className={`h-36 w-full object-cover ${
                                                                imageIndex === 0 ? "border-r-2 border-black" : ""
                                                            }`}
                                                            loading="lazy"
                                                        />
                                                    ))}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            )}
                        </article>
                    ))}
                </div>
            </section>
        </PageShell>
    );
};

export default Stockists;
